import { render } from "./PayPalCancel.vue?vue&type=template&id=210331f6&scoped=true"
import script from "./PayPalCancel.vue?vue&type=script&lang=js"
export * from "./PayPalCancel.vue?vue&type=script&lang=js"

import "./PayPalCancel.vue?vue&type=style&index=0&id=210331f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210331f6"]])

export default __exports__